module.exports = __webpack_public_path__ + "static/img/ios-app-link-qr.facba03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios-app-link-qr.svg
// module id = 594
// module chunks = 180